import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { IUpdateModelBioRequest } from "./request.types";
import type { TGetModelBioResponse } from "./response.types";

class ModelBioController extends Controller {
	public constructor() {
		super({ requestUrl: "models/" });
	}

	/**@GET BIO DATA */
	public async getModelBioAsync({ token }: IRequestConfig) {
		return this.get<TGetModelBioResponse>("base", "bio", { token });
	}

	/**@POST UPDATE BIO DATA */
	public async updateModelBioAsync({ token, body }: IUpdateModelBioRequest) {
		return this.post<void>("bio", body, { token });
	}
}

export const modelBioAPI = new ModelBioController();
